import { useBusinessFromRoute } from "../hooks/useBusinessFromRoute";
import { selectOrganization } from "../redux/organizationSlice";
import { selectUser } from "../redux/userSlice";
import { useAppSelector } from "../redux/hooks";
import Pordal from "../components/shared/Pordal";
import BusinessInvestigationTool from "../components/BusinessDetails/BusinessInvestigationTool";

export default function InvestigateBusiness() {
  const organization = useAppSelector(selectOrganization);
  const user = useAppSelector(selectUser);
  const business = useBusinessFromRoute();

  if (!business || !organization || !user) {
    return <></>;
  }

  return (
    <Pordal>
      <BusinessInvestigationTool
        business={business}
        organization={organization}
        user={user}
      />
    </Pordal>
  );
}
